import * as React from "react";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { FormattedMessage } from "react-intl";
import Link from "./link";
import BookingModal from "./booking-modal";
import QuestionModal from "./question-modal";

const renderOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      const [{ value }] = node.content;

      if (value !== "" || node.content.length > 1) {
        return <p>{children}</p>;
      }

      return null;
    },

    [INLINES.HYPERLINK]: (node, children) => (
      <Link href={node.data.uri}>{children}</Link>
    ),
  },

  renderText: (text) => {
    return text
      .split("\n")
      .flatMap((text, index) => [index > 0 && <br key={index} />, text]);
  },
};

const Booking = ({
  children,
  product,
  reassurances,
  urlFillout,
  bookingHeading,
  ctaLabel,
  privatiseUrl,
  privatiseText,
}) => {
  const bookingModalTriggerRef = React.useRef(null);
  const questionModalTriggerRef = React.useRef(null);

  const [isBookingModalOpen, setIsBookingModalOpen] = React.useState(false);
  const [isQuestionModalOpen, setIsQuestionModalOpen] = React.useState(false);

  const openBookingModal = () => setIsBookingModalOpen(true);
  const closeBookingModal = () => setIsBookingModalOpen(false);

  const openQuestionModal = () => setIsQuestionModalOpen(true);
  const closeQuestionModal = () => setIsQuestionModalOpen(false);

  return (
    <section id="booking" className="booking" aria-labelledby="booking-heading">
      <div className="container">
        <div className="booking-content">
          <h2 id="booking-heading" className="heading">
            <FormattedMessage id="bookingHeading" />
          </h2>
          {children && renderRichText(children, renderOptions)}
        </div>
        <div className="booking-widget" id="booking-widget">
          <div>
            <h2 className="heading">
              {bookingHeading ? (
                bookingHeading
              ) : (
                <FormattedMessage id="chooseDates" />
              )}
            </h2>
            <p className="booking-price">
              <FormattedMessage id="from" /> : <span>{product.price}€</span>
            </p>
            <div className="booking-actions">
              <button
                className="button-orange"
                onClick={openBookingModal}
                ref={bookingModalTriggerRef}
              >
                {ctaLabel ? ctaLabel : <FormattedMessage id="viewDepartures" />}
              </button>
              <button
                className="button-ghost"
                onClick={openQuestionModal}
                ref={questionModalTriggerRef}
              >
                <FormattedMessage id="haveAQuestion" />
              </button>
            </div>
            {product.displayPrivatiseBanner === true && (
              <Link href={privatiseUrl ? privatiseUrl : "/contact"}>
                {privatiseText ? (
                  privatiseText
                ) : (
                  <FormattedMessage id="privatizeYourTrip" />
                )}
              </Link>
            )}
            <div className="booking-reassurances">
              {reassurances && renderRichText(reassurances, renderOptions)}
            </div>
          </div>
        </div>
      </div>
      <QuestionModal
        isOpen={isQuestionModalOpen}
        onClose={closeQuestionModal}
        presentation={""}
        renderOptions={renderOptions}
        triggerRef={questionModalTriggerRef}
      />
      <BookingModal
        isOpen={isBookingModalOpen}
        onClose={closeBookingModal}
        triggerRef={bookingModalTriggerRef}
        urlFillout={urlFillout}
      />
    </section>
  );
};

export default Booking;
